/*------------------------------------------------
// File Name:PDM_BodyCheck_FenLei.js
// File Description:PDM_BodyCheck_FenLei store方法
// Author:zxl
// Create Time:2023/04/03 18:29:43
//------------------------------------------------*/

import {
    GetPDM_BodyCheck_FenLeiList,
    GetPDM_BodyCheck_FenLeiListByPage,
    GetPDM_BodyCheck_FenLeiEntity,
    CreatePDM_BodyCheck_FenLeiEntity,
    UpdatePDM_BodyCheck_FenLeiEntity,
    DeletePDM_BodyCheck_FenLeiEntity,
} from '@/api/pdm/bodycheckFenlei'

import msg from '@/config/notify'
import dlg from '@/config/dialog'
//import { toRaw } from "vue";

export const PdmBodycheckFenlei = {
    namespaced: true,
    state: {
        PdmBodycheckFenleiList: [],
        PdmBodycheckFenleiListLoading: false,
        PdmBodycheckFenleiEntity: null,
        PdmBodycheckFenleiShowDlg: false,
    },
    mutations: {
        setPdmBodycheckFenleiList(state, dataList) {
            state.PdmBodycheckFenleiList = [...dataList]
        },
        setPdmBodycheckFenleiListLoading(state, visible) {
            state.PdmBodycheckFenleiListLoading = visible
        },
        setPdmBodycheckFenleiShowDlg(state, visible) {
            state.PdmBodycheckFenleiShowDlg = visible
        },
        setPdmBodycheckFenleiEntity(state, entity) {
            state.PdmBodycheckFenleiEntity = entity
        },
    },
    actions: {
        //创建对象
        actCreatePdmBodycheckFenlei({ commit }, parm) {
            return new Promise((resolve, reject) => {
                CreatePDM_BodyCheck_FenLeiEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckFenleiEntity', res.Data)
                        commit('setPdmBodycheckFenleiShowDlg', true)
                         //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        reject(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载对象
        actGetPdmBodycheckFenleiEntity({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmBodycheckFenleiListLoading', true)
                GetPDM_BodyCheck_FenLeiEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckFenleiEntity', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmBodycheckFenleiListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载列表
        actGetPdmBodycheckFenleiList({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmBodycheckFenleiListLoading', true)
                GetPDM_BodyCheck_FenLeiList(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckFenleiList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmBodycheckFenleiListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //分页加载列表
        actGetPdmBodycheckFenleiListByPage({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmBodycheckFenleiListLoading', true)
                GetPDM_BodyCheck_FenLeiListByPage(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckFenleiList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                       // msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmBodycheckFenleiListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //保存信息
        actUpdatePdmBodycheckFenlei({ commit }, parm) {
            return new Promise((resolve) => {
                UpdatePDM_BodyCheck_FenLeiEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckFenleiShowDlg', false)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_BodyCheck_FenLei
        actEditPdmBodycheckFenleiData({ commit }, entity) {
            return new Promise((resolve) => {
                let parm = {                    
                    PdmBodycheckFenleiID : entity.PdmBodycheckFenleiID
                }
                GetPDM_BodyCheck_FenLeiEntity(parm).then(res => {
                    if (res.Code == 0) {
                        // var info = {}
                        // Object.assign(info,state.getTableNameL3(TableName.Name)%>Entity)
                        // Object.assign(info,res.Data)
                        // commit('getTableNameL3(TableName.Name)%>Entity', info)
                        commit('setPdmBodycheckFenleiEntity', res.Data)
                        commit('setPdmBodycheckFenleiShowDlg', true)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_BodyCheck_FenLei ,传对象过来
        actEditPdmBodycheckFenlei({ commit }, entity) {
            return new Promise(() => {
                commit('setPdmBodycheckFenleiEntity', entity)
                commit('setPdmBodycheckFenleiShowDlg', true)
            }).catch(err => {
                console.log(err)
            })
        },
        //删除PDM_BodyCheck_FenLei
        actDeletePdmBodycheckFenlei({ commit }, e) {
            return new Promise((resolve) => {
                dlg.confirm("是否确定要删除当前？").onOk(() => {
                    DeletePDM_BodyCheck_FenLeiEntity(e).then(res => {
                        if (res.Code == 0) {
                            commit('setPdmBodycheckFenleiShowDlg', false)
                           
                            msg.success("删除成功。")
                            resolve(res)
                        } else {
                            dlg.alert("删除失败，原因:" + res.Message)
                            //msg.success("删除失败，原因:" + res.Message)
                            resolve(res)
                        }
                    })
                })
            }).catch(err => {
                console.log(err)
            })
        }
    }
}


